import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import ServiceProviderAppResource from "./ServiceProviderAppResource";
import OrganizationAppResource from "./OrganizationAppResource";
import ServiceProviderContactAppResource from "./ServiceProviderContactAppResource";
import UserAppResource from "./UserAppResource";
import Engine from "@milestoneslabs/milestones-js-engine/src/Engine";
import ServiceProviderRecommendationTypeAppResource from './ServiceProviderRecommendationTypeAppResource';

class ServiceProviderRecommendationAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'service-provider-recommendation';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'services/providers/recommendations';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'organizationUuid',
            'userUuid',
            'serviceProviderUuid',
            'serviceProviderContactUuid',
            'typeUuid',
            'organization',
            'user',
            'serviceProvider',
            'serviceProviderContact',
            'type',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            organization: OrganizationAppResource,
            user: UserAppResource,
            serviceProvider: ServiceProviderAppResource,
            serviceProviderContact: ServiceProviderContactAppResource,
            type: ServiceProviderRecommendationTypeAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {
            organization: 'organization_uuid',
            user: 'user_uuid',
            serviceProvider: 'service_provider_uuid',
            serviceProviderContact: 'service_provider_contact_uuid',
            type: 'type_uuid',
        };
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            organizationUuid: {
                type: 'string',
            },
            userUuid: {
                type: 'string',
            },
            serviceProviderUuid: {
                type: 'string',
                presence: true,
            },
            serviceProviderContactUuid: {
                type: 'string',
            },
            typeUuid: {
                type: 'string',
                presence: true,
            },
        };
    }

    apiPaths() {
        return {
            ...super.apiPaths(),
            'search-resources': Engine.apiUrl(this.appResourceApiPrefix() + '/search/resources'),
            'search-organizations-users': Engine.apiUrl(this.appResourceApiPrefix() + '/search/organizations-users'),
        };
    }

    async fetchResourceRecommendations(data) {
        const url = this.apiPaths()['search-resources'];
        const apiResponse = await this.enginePost(url, data);

        this._emitter.emit('loaded', this, apiResponse);

        return apiResponse;
    }

    async fetchResourceRecommendationOrganizationsAndUsers(data) {
        const url = this.apiPaths()['search-organizations-users'];
        const apiResponse = await this.enginePost(url, data);

        this._emitter.emit('loaded', this, apiResponse);

        return apiResponse;
    }
}

export default ServiceProviderRecommendationAppResource;
